import { actions } from './action'

const initialState = {
  attendanceIssueList: [],
  totalCount: null,
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
  pagination: {
    skip: 0,
    limit: 10,
  },
}

const onAttendanceIssue = (state = initialState, action) => {
  switch (action.type) {
    case actions.HANDLE_ATTENDANCE_ISSUE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.HANDLE_ATTENDANCE_ISSUE: {
      return {
        ...state,
        attendanceIssueList: action.payload.attendanceIssueList,
        totalCount: action.payload.totalCount,
      }
    }

    default:
      return state
  }
}

export default onAttendanceIssue
